import CredentialCard from "./CredentialCard";

export default CredentialCard;
